"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SingleTargetStrategyBuilder_1 = require("./SingleTargetStrategyBuilder");

var SingleTargetStrategyConverter_1 = require("./SingleTargetStrategyConverter");
/**
 * Default implementation of {@link SimpleConstraintConverter}.
 *
 * @author RV
 */


var SingleTargetStrategyConverterImpl =
/*#__PURE__*/
function (_SingleTargetStrategy) {
  _inherits(SingleTargetStrategyConverterImpl, _SingleTargetStrategy);

  function SingleTargetStrategyConverterImpl() {
    _classCallCheck(this, SingleTargetStrategyConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SingleTargetStrategyConverterImpl).apply(this, arguments));
  }

  _createClass(SingleTargetStrategyConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SingleTargetStrategyBuilder_1.SingleTargetStrategyBuilder(this.deserializeStrategyType(source, conversions), conversions.toClassReferenceId(source.competitorId)).build();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        competitorId: conversions.toDocumentReferenceId(source.competitorId),
        strategyType: source.getType()
      });
      return result;
    }
  }]);

  return SingleTargetStrategyConverterImpl;
}(SingleTargetStrategyConverter_1.SingleTargetStrategyConverter);

exports.SingleTargetStrategyConverterImpl = SingleTargetStrategyConverterImpl;